import { render, staticRenderFns } from "./Warranties.vue?vue&type=template&id=aa8042f2"
import script from "./Warranties.vue?vue&type=script&lang=ts"
export * from "./Warranties.vue?vue&type=script&lang=ts"
import style0 from "./Warranties.vue?vue&type=style&index=0&id=aa8042f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports